module.exports = __webpack_public_path__ + "static/carpenter-53721c6763ac3966d9756346c3afe59b.png";